import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Grid from '@material-ui/core/Grid'
import { API } from '@const'
import * as utils from '@utils'
import Divider from '@material-ui/core/Divider'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import { InputLabel, TextField, Typography } from '@material-ui/core/'

class ManualPrizeDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'ManualPrizeDialog', options)
        }
    }

    state = {
        input: {
            oid: 0,
            bet_range: [5, 50],
            claim_prize: '',
        },
        dialogOpen: false,
        prizeList: {},
        isLoading: false,
    }

    componentDidMount() {
        this.props.onRef(this)
        this.queryPrizeList()
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    queryPrizeList = () => {
        utils.apiRequest(
            'get',
            API.RISKMGT_COMPENSATION_PRIZE_LIST,
            {},
            (data) => {
                if (data) {
                    const oid = Object.keys(data)[0]
                    this.setState({
                        prizeList: data,
                        input: {
                            ...this.state.input,
                            oid: oid,
                            claim_prize: Object.entries(data[oid].prize_list).sort(([_a_key, a], [_b_key, b]) =>
                                a[0].multiple_boundary[0] > b[0].multiple_boundary[0] ? 1 : -1
                            )[0][1][0].key,
                            bet_range: data[oid].available_bet_range,
                        },
                    })
                }
            },
            (_err) => {
                this.setState({ prizeList: {} })
            },
            true
        )
    }

    reset() {
        this.setState({ isLoading: false })
    }

    OpenDialog(_input) {
        this.reset()
        this.setState({ dialogOpen: true })
    }

    CloseDialog() {
        this.setState({ dialogOpen: false })
    }

    render() {
        return (
            <Dialog open={this.state.dialogOpen} onClose={() => this.setState({ dialogOpen: false })} fullWidth maxWidth="sm">
                <DialogTitle>{this.t('Title')}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <FormControl className={this.props.classes.formControl}>
                                <InputLabel shrink>{this.t('game')}</InputLabel>
                                <Select
                                    value={this.state.input.oid}
                                    onChange={(event) =>
                                        this.setState({
                                            input: {
                                                ...this.state.input,
                                                oid: event.target.value,
                                                claim_prize: Object.entries(this.state.prizeList[event.target.value].prize_list).sort(
                                                    ([_a_key, a], [_b_key, b]) => (a[0].multiple_boundary[0] > b[0].multiple_boundary[0] ? 1 : -1)
                                                )[0][1][0].key,
                                                bet_range: this.state.prizeList[event.target.value].available_bet_range,
                                            },
                                        })
                                    }>
                                    {Object.entries(this.state.prizeList).map(([key, elem]) => {
                                        return (
                                            <MenuItem value={key} key={key}>
                                                {key +
                                                    ': ' +
                                                    this.t('GameName.' + elem.game_code) +
                                                    ' (' +
                                                    this.t('RoomType.' + elem.room_type_code_id) +
                                                    ')'}
                                            </MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            {this.state.prizeList[this.state.input.oid]
                                ? '指定下注區間：(' + this.state.prizeList[this.state.input.oid].available_bet_range.join(' - ') + ')'
                                : ''}
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                label={this.t('minBet')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.input.bet_range[0]}
                                onChange={(event) => {
                                    const min_bet = this.state.prizeList[this.state.input.oid].available_bet_range[0]
                                    const max_bet = this.state.prizeList[this.state.input.oid].available_bet_range[1]
                                    let value = Math.max(event.target.value, min_bet)
                                    value = Math.min(value, max_bet)
                                    if (Number.isNaN(value)) value = min_bet
                                    this.setState({
                                        input: {
                                            ...this.state.input,
                                            bet_range: [value, this.state.input.bet_range[1]],
                                        },
                                    })
                                }}
                                className={this.props.classes.textField}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                label={this.t('maxBet')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.input.bet_range[1]}
                                onChange={(event) => {
                                    const min_bet = this.state.prizeList[this.state.input.oid].available_bet_range[0]
                                    const max_bet = this.state.prizeList[this.state.input.oid].available_bet_range[1]
                                    let value = Math.max(event.target.value, min_bet)
                                    value = Math.min(value, max_bet)
                                    if (Number.isNaN(value)) value = min_bet
                                    this.setState({
                                        input: {
                                            ...this.state.input,
                                            bet_range: [this.state.input.bet_range[0], value],
                                        },
                                    })
                                }}
                                className={this.props.classes.textField}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl className={this.props.classes.formControl}>
                                <InputLabel shrink>{this.t('claimPrize')}</InputLabel>
                                <Select
                                    value={this.state.input.claim_prize}
                                    onChange={(event) =>
                                        this.setState({
                                            input: {
                                                ...this.state.input,
                                                claim_prize: event.target.value,
                                            },
                                        })
                                    }>
                                    {this.state.prizeList[this.state.input.oid]
                                        ? Object.entries(this.state.prizeList[this.state.input.oid].prize_list)
                                              .sort(([_a_key, a], [_b_key, b]) => (a[0].multiple_boundary[0] > b[0].multiple_boundary[0] ? 1 : -1))
                                              .map(([key, elem]) => (
                                                  <MenuItem value={key} key={key}>
                                                      {elem[0].name +
                                                          ' (' +
                                                          (elem[0].multiple_boundary
                                                              ? elem[0].multiple_boundary[0] === elem[0].multiple_boundary[1]
                                                                  ? elem[0].multiple_boundary[0]
                                                                  : elem[0].multiple_boundary.join(' ~ ')
                                                              : '') +
                                                          ' 倍)'}
                                                  </MenuItem>
                                              ))
                                        : ''}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography color="error">
                            {this.state.input['bet_range'] &&
                                this.state.prizeList[this.state.input.oid] &&
                                this.t('PrizeRange', {
                                    min:
                                        this.state.input['bet_range'][0] *
                                        this.state.prizeList[this.state.input.oid].prize_list[this.state.input.claim_prize][0].multiple_boundary[0],
                                    max:
                                        this.state.input['bet_range'][1] *
                                        this.state.prizeList[this.state.input.oid].prize_list[this.state.input.claim_prize][0].multiple_boundary[1],
                                })}
                        </Typography>
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={() => {
                            this.setState({ isLoading: true })

                            if (parseFloat(this.state.input.bet_range[0]) > parseFloat(this.state.input.bet_range[1])) {
                                utils.addToast(this.t('invalidParams'), 'error')
                                this.setState({ isLoading: false })
                                return
                            }

                            utils.apiRequest(
                                'post',
                                API.RISKMGT_COMPENSATION,
                                {
                                    ...this.state.input,
                                    oid: parseInt(this.state.input.oid),
                                    bet_range: [parseFloat(this.state.input.bet_range[0]), parseFloat(this.state.input.bet_range[1])],
                                    pf_account: this.props.ownerState.pf_account,
                                },
                                (_data) => {
                                    this.props.confirmCallback()
                                    this.CloseDialog()
                                },
                                (_err) => {
                                    this.setState({ isLoading: false })
                                }
                            )
                        }}
                        color="primary"
                        disabled={this.state.isLoading}>
                        {this.t('confirm')}
                    </Button>
                    <Button variant="contained" onClick={() => this.CloseDialog()} color="primary">
                        {this.t('cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

ManualPrizeDialog.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string),
    onRef: PropTypes.func.isRequired,
    confirmCallback: PropTypes.func,
    ownerState: PropTypes.object,
}

const styles = (_theme) => ({})

export default hoc(styles)(ManualPrizeDialog)
